module.exports = __webpack_public_path__ + "static/media/28.67ebc8d5.png";